module.exports = __webpack_public_path__ + "images/feature/group-3-f8ea1565a9205cef398218badb0d7940.jpg";